import { FC } from "react";
import styles from "./VersusBar.module.scss";
import { classNames, statitics } from "@/lib/utils";
import { useAtomValue } from "jotai";
import { greyMediumState, themeState } from "@/lib/store";

interface PropsTypes {
    title?: string;
    data: number[];
    value: number;
    bigFont?: boolean;
}

const VersusBar: FC<PropsTypes> = ({ title, data, value, bigFont }) => {
    const theme = useAtomValue(themeState);
    const greyMedium = useAtomValue(greyMediumState);

    if (!data) return <p className={classNames(styles.VersusBar, styles[bigFont && "big-font"])}>N/A</p>;

    const boxWidth = 30;
    let left;
    const [min, q1, q2, q3, max] = statitics(data);
    if (value > max) left = 100;
    else if (value > q3 && max - q3 > 0) left = ((value - q3) / (max - q3)) * (50 - boxWidth / 2) + (50 + boxWidth / 2);
    else if (value > q2 && q3 - q2 > 0) left = ((value - q2) / (q3 - q2)) * (boxWidth / 2) + 50;
    else if (value > q1 && q2 - q1 > 0) left = ((value - q1) / (q2 - q1)) * (boxWidth / 2) + (50 - boxWidth / 2);
    else if (value > min && q1 - min > 0) left = ((value - min) / (q1 - min)) * (50 - boxWidth / 2);
    else left = 0;

    return (
        <div className={classNames(styles.VersusBar, styles[bigFont && "big-font"])}>
            <style jsx>{`
                .${styles.labels} {
                    color: var(--text-3, #8a8f97);
                }
                .${styles.hline}, .${styles.vline}, .${styles.box} {
                    background-color: ${greyMedium};
                }
            `}</style>
            <p>{title}</p>
            <div className={styles.container}>
                <div className={styles.box} style={{ width: boxWidth + "%" }}></div>
                <div className={styles.hline}></div>
                <div className={classNames(styles.vline, styles.left)}></div>
                <div className={classNames(styles.vline, styles.right)}></div>
                <div className={classNames(styles[theme], styles.pointer)} style={{ left: left + "%" }}>
                    <div className={styles.bar}></div>
                    <div className={styles.bottom}></div>
                </div>
            </div>
            <div className={styles.labels}>
                <p className={classNames(styles.label, styles.left)}>Low</p>
                <p className={classNames(styles.label, styles.right)}>High</p>
            </div>
        </div>
    );
};

export default VersusBar;
